// @ts-strict-ignore
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button } from '@node-space/ui-components'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import { PathNames } from 'constants/General'
import { ExternalLinks } from 'constants/links'
import { locationReload } from 'utils/location'

export interface MappedErrorMessageProps {
  errorCode?: number
  fallbackMessage?: React.ReactNode
}

export const MappedErrorMessage = ({ errorCode, fallbackMessage }: MappedErrorMessageProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const textAction = {
    contactSupport: (
      <ExternalLink href={ExternalLinks.CONTACT_SUPPORT}>
        {t('errorMessages.contactSupport')}
      </ExternalLink>
    ),
    expiredSession: (
      <Button variant="ghost" noPadding onClick={locationReload}>
        {t('errorMessages.expiredLoginSession')}
      </Button>
    ),
    manageTeamMembers: (
      <Button
        variant="ghost"
        noPadding
        onClick={() => navigate(`${PathNames.SETTINGS}${PathNames.MANAGE_TEAM_MEMBERS}`)}
      >
        {t('teamMember.workspaceOwner')}
      </Button>
    ),
    reload: (
      <Button variant="ghost" noPadding onClick={locationReload}>
        {t('errorMessages.reload')}
      </Button>
    ),
  }

  const tryLaterOrContactSupport = (
    <span className="text-body-regular text-inherit">
      {`${t('errorMessages.tryAgainLater')} `}
      {textAction.contactSupport}.
    </span>
  )

  if (errorCode >= 500) {
    return (
      <p className="text-body-regular text-inherit">
        {`${t('errorMessages.error5xx')} `}
        {tryLaterOrContactSupport}
      </p>
    )
  }

  switch (errorCode) {
    case 401:
      return (
        <p className="text-body-regular text-inherit">
          {`${t('errorMessages.error401')} `}
          {textAction.expiredSession}.
        </p>
      )
    case 403:
      return (
        <p className="text-body-regular text-inherit">
          {t('errorMessages.error403Start')}
          {textAction.manageTeamMembers}
          {t('errorMessages.error403End')}
        </p>
      )
    case 429:
      return (
        <p className="text-body-regular text-inherit">
          {`${t('errorMessages.error429')} `}
          {tryLaterOrContactSupport}
        </p>
      )

    default:
      return (
        <p className="text-body-regular text-inherit">
          {fallbackMessage ?? t('errorMessages.errorOccured')}
          {` ${t('errorMessages.please')} `}
          {textAction.reload}
          {` ${t('errorMessages.or')} `}
          {textAction.contactSupport}.
        </p>
      )
  }
}
